import { newAxiosIns } from '@/libs/axios'

const URL = '/auth/api/v1/partner/payment_interface'

export function apiGetPaymentInterface() {
  return newAxiosIns.get(URL)
}

export function apiCreatePaymentInterface(param) {
  const params = {
    ...param,
  }
  return newAxiosIns.get(URL, { params })
}
